"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UseCaseGraphNode = exports.UseCaseNodeType = void 0;
const Utilities_1 = require("../../../TdWebtoolkitControls/javascript/Utilities");
var UseCaseNodeType;
(function (UseCaseNodeType) {
    UseCaseNodeType[UseCaseNodeType["VirtualRoot"] = 1] = "VirtualRoot";
    UseCaseNodeType[UseCaseNodeType["Group"] = 2] = "Group";
    UseCaseNodeType[UseCaseNodeType["UseCase"] = 4] = "UseCase";
})(UseCaseNodeType = exports.UseCaseNodeType || (exports.UseCaseNodeType = {}));
class UseCaseGraphNode {
    constructor(id, name, description, type, dataObject, iconDocId, cssColor) {
        this.m_id = id;
        this.m_name = name;
        this.m_description = description;
        this.m_type = type;
        this.m_dataObject = dataObject;
        this.m_iconDocId = iconDocId;
        this.m_cssColor = cssColor;
    }
    static GetLangString(stringMap) {
        let ui = Utilities_1.synUtil.UserInfo.getUserInfo();
        let langId = ui.UILanguageId;
        let langString = stringMap[langId];
        if (!langString)
            langString = stringMap["1"];
        return langString;
    }
    static GetUseCase(useCaseId, name, description, dataObject) {
        let title = UseCaseGraphNode.GetLangString(dataObject.title);
        let desc = UseCaseGraphNode.GetLangString(dataObject.description);
        if (typeof UseCaseGraphNode.m_mapUseCases[useCaseId] === "undefined")
            UseCaseGraphNode.m_mapUseCases[useCaseId] = new UseCaseGraphNode(useCaseId, title, desc, UseCaseNodeType.UseCase, dataObject, dataObject.iconDocId, dataObject.color);
        return UseCaseGraphNode.m_mapUseCases[useCaseId];
    }
    static GetGroupNode(groupId, name, comments, iconDocId, cssColor) {
        if (typeof UseCaseGraphNode.m_mapGroupNodes[groupId] === "undefined")
            UseCaseGraphNode.m_mapGroupNodes[groupId] = new UseCaseGraphNode(groupId, name, comments, UseCaseNodeType.Group, undefined, iconDocId, cssColor);
        return UseCaseGraphNode.m_mapGroupNodes[groupId];
    }
    static GetVirtualRoot() {
        if (!UseCaseGraphNode.m_virtualRoot)
            UseCaseGraphNode.m_virtualRoot
                = new UseCaseGraphNode("f77ecad243c54a5f835284957f073264", "(Root)", undefined, UseCaseNodeType.VirtualRoot, undefined, undefined, undefined);
        return UseCaseGraphNode.m_virtualRoot;
    }
}
exports.UseCaseGraphNode = UseCaseGraphNode;
UseCaseGraphNode.m_mapGroupNodes = {};
UseCaseGraphNode.m_mapUseCases = {};
